import { withEventScope } from '@repo/event-processor';
import { Button, menuSmallTheme } from '@repo/ui/components/Buttons';
import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import MinusThinIcon from '@repo/ui/components/Icon/MinusThinIcon';
import PlusThinIcon from '@repo/ui/components/Icon/PlusThinIcon';
import { Popover } from '@repo/ui-kit/components/core/Popover';

import { MenuButton, MenuWrapper } from './styles';
import { MenuProps } from './types';

const Menu = ({
  canFollow,
  handleFollow,
  followLabel,
  canReport,
  handleReport,
  buttonHeight,
  align,
}: MenuProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger>
        <MenuButton
          $buttonHeight={buttonHeight}
          data-testid="design-post-menu-button"
        >
          <div />
          <div />
          <div />
        </MenuButton>
      </Popover.Trigger>
      <Popover.Content align={align} sideOffset={12}>
        <MenuWrapper data-testid="design-post-menu">
          <ul>
            {canFollow && (
              <li>
                <Popover.Close>
                  <Button
                    icon={{
                      component:
                        followLabel === 'Follow' ? PlusThinIcon : MinusThinIcon,
                    }}
                    isCentered={false}
                    label={followLabel}
                    name="toggleFollowButton"
                    theme={{ ...menuSmallTheme, padding: '8px' }}
                    width="100%"
                    onClick={handleFollow}
                  />
                </Popover.Close>
              </li>
            )}
            {canReport && (
              <li>
                <Popover.Close>
                  <Button
                    icon={{ component: InfoThickIcon }}
                    isCentered={false}
                    label="Report"
                    name="menuReportButton"
                    theme={{ ...menuSmallTheme, padding: '8px' }}
                    width="100%"
                    onClick={handleReport}
                  />
                </Popover.Close>
              </li>
            )}
          </ul>
        </MenuWrapper>
      </Popover.Content>
    </Popover.Root>
  );
};

export default withEventScope(Menu, { module: 'designPostMenu' });
